import { z } from 'zod';
import { PERMISSIONS, terraContract } from '@terra/shared-authorization';
import { INTERNAL_NETWORK_TUNNEL_PATH_NAME } from './internal-network-tunnel.constants';
import {
  InternalNetworkTunnelErrorResponseSchema,
  InternalNetworkTunnelRevokeRequestSchema,
  InternalNetworkTunnelRevokeResponseSchema,
  InternalNetworkTunnelSessionRequestSchema,
  InternalNetworkTunnelSessionSchema,
} from './internal-network-tunnel.schemas';
import {
  GetTargetTunnelRequirementQuerySchema,
  TunnelRequirementSchema,
} from './target-tunnel-requirement.schema';

export const InternalNetworkTunnelContract = terraContract
  .prefix(`/${INTERNAL_NETWORK_TUNNEL_PATH_NAME}`)
  .router({
    createSession: terraContract
      .meta({
        permissions: [PERMISSIONS.EXECUTE_INTERNAL_NETWORK_TUNNEL.name],
      })
      .route({
        method: 'POST',
        path: '/sessions',
        summary: 'Start an internal network tunnel session',
        inputStructure: 'detailed',
        successStatus: 201,
      })
      .input(z.object({ body: InternalNetworkTunnelSessionRequestSchema }))
      .output(InternalNetworkTunnelSessionSchema)
      .errors({
        BAD_REQUEST: {
          status: 400,
          data: InternalNetworkTunnelErrorResponseSchema,
        },
        UNAUTHORIZED: {
          status: 401,
          data: InternalNetworkTunnelErrorResponseSchema,
        },
        FORBIDDEN: {
          status: 403,
          data: InternalNetworkTunnelErrorResponseSchema,
        },
      }),
    revokeSession: terraContract
      .meta({
        permissions: [PERMISSIONS.EXECUTE_INTERNAL_NETWORK_TUNNEL.name],
      })
      .route({
        method: 'POST',
        path: '/sessions/revoke',
        summary: 'Revoke an internal network tunnel session',
        inputStructure: 'detailed',
      })
      .input(z.object({ body: InternalNetworkTunnelRevokeRequestSchema }))
      .output(InternalNetworkTunnelRevokeResponseSchema)
      .errors({
        UNAUTHORIZED: {
          status: 401,
          data: InternalNetworkTunnelErrorResponseSchema,
        },
        FORBIDDEN: {
          status: 403,
          data: InternalNetworkTunnelErrorResponseSchema,
        },
      }),
    getTargetRequirement: terraContract
      .route({
        method: 'GET',
        path: '/target-requirement',
        summary: 'Get the internal network tunnel requirement for a target',
        inputStructure: 'detailed',
      })
      .input(z.object({ query: GetTargetTunnelRequirementQuerySchema }))
      .output(TunnelRequirementSchema)
      .errors({
        BAD_REQUEST: {
          status: 400,
          data: InternalNetworkTunnelErrorResponseSchema,
        },
        UNAUTHORIZED: {
          status: 401,
          data: InternalNetworkTunnelErrorResponseSchema,
        },
      }),
  });
